import { Controller } from "@hotwired/stimulus";

/**
 * PhoneWarningController monitors a checkbox and phone number field,
 * displaying a warning when the checkbox is checked but no phone number is entered.
 *
 * Targets:
 *   - checkbox: The SMS notification checkbox
 *   - warning: The warning message element to show/hide
 *   - phone: The phone number input field (optional, will search if not specified)
 *
 * @example
 * <div data-controller="phone-warning">
 *   <input type="text" id="user_sms_notification_number" data-phone-warning-target="phone">
 *   <input type="checkbox" data-phone-warning-target="checkbox" data-action="change->phone-warning#checkWarning">
 *   <div data-phone-warning-target="warning" class="d-none text-danger">Warning message</div>
 * </div>
 */
export default class extends Controller {
  static targets = ["checkbox", "warning", "phone"];

  connect() {
    if (!this.hasPhoneTarget) {
      this.phoneInput = document.getElementById("user_sms_notification_number");
    } else {
      this.phoneInput = this.phoneTarget;
    }

    if (this.phoneInput) {
      this.phoneInput.addEventListener("input", this.checkWarning.bind(this));
    }

    this.checkWarning();
  }

  disconnect() {
    if (this.phoneInput) {
      this.phoneInput.removeEventListener("input", this.checkWarning.bind(this));
    }
  }

  checkWarning() {
    const checkboxChecked = this.checkboxTarget.checked;
    const phoneEmpty = !this.phoneInput || this.phoneInput.value.trim() === "";

    if (checkboxChecked && phoneEmpty) {
      this.warningTarget.classList.remove("d-none");
    } else {
      this.warningTarget.classList.add("d-none");
    }
  }
}
